module.exports = __webpack_public_path__ + "static/banner-two-shape10-814cd9b5041ccf6edc1c3f4747f6beab.png";